export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7928.f3009a4d.jpg";